import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { QueryColumn } from '@barthauer/abc/core/data';
import {
  AbcPopupComponent,
  AbcSpeedDialActionComponent,
  _AbcContextMenuComponent,
  _AbcGridComponent,
} from '@barthauer/abc/ui-components';
import { DxDataGridModule } from 'devextreme-angular';
import { Column } from 'devextreme/ui/data_grid';
import { DefaultIcons } from 'libs/custom/xmt/models/src/lib/model/enumeration-list.model';
import { Subscription } from 'rxjs';
import { first } from 'rxjs/operators';
import { AppService } from '../services/app.service';
import { DataService, ObjectKeys } from '../services/data.service';
import { PermessionService } from '../services/permession.service';
import { SharedModule } from '../shared/shared.module';
import { UbtLoaderComponent } from '../shared/ubt-loader/ubt-loader.component';
import { UserRightPopupComponent } from './user-right-popup/user-right-popup.component';

@Component({
  selector: 'ubt-geods-user-right',
  templateUrl: './user-right.component.html',
  styleUrls: ['./user-right.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    SharedModule,
    _AbcGridComponent,
    DxDataGridModule,
    AbcSpeedDialActionComponent,
    _AbcContextMenuComponent,
    AbcPopupComponent,
    UserRightPopupComponent,
    UbtLoaderComponent,
  ],
})
export class UserRightComponent implements OnInit, OnDestroy {
  @ViewChild('createUserPopup', { static: false }) createUserPopup: UserRightPopupComponent;
  @ViewChild('rolesGrid') rolesGrid: _AbcGridComponent;
  @ViewChild('contextMenu') contextMenu: _AbcContextMenuComponent;
  public roleId: string;
  public loadPopup = false;
  public showLoader: boolean = true;
  public columnsHeader: Column[] = [
    {
      caption: this.dataService.res('Ubt-GridColumn-Name'),
      dataField: 'Description',
      dataType: 'string',
      visibleIndex: 0,
      sortOrder: 'asc',
    },
    {
      type: 'buttons',
      caption: '',
      alignment: 'left',
      dataField: '',
      visibleIndex: 1,
      minWidth: 50,
      width: '50px',
    },
  ];
  public dataSource: GlobalRole[] = [];

  public readonly pickListItemColumns: QueryColumn[] = [
    {
      OPath: 'Id',
      Name: 'Id',
    },
    {
      OPath: 'Description',
      Name: 'Description',
    },
    {
      OPath: 'Value',
      Name: 'Value',
    },
    {
      OPath: 'ParentId',
      Name: 'ParentId',
    },
  ];
  public contextMenuItems: any[] = [
    {
      text: this.dataService.res('Ubt-Roles-Rights-Edit-Role'),
      onClick: () => {
        this.openEditDialog();
      },
    },
  ];
  public noDataText = this.dataService.res('Ubt-No-Data-text');
  private subscriptions: Subscription[] = [];
  public availableRoles: GlobalRole[] = [];
  constructor(
    public dataService: DataService,
    public appService: AppService,
    private cdr: ChangeDetectorRef,
    public permessionService: PermessionService
  ) {}

  public ngOnDestroy(): void {
    this.subscriptions.map((subscription) => subscription.unsubscribe());
  }

  ngOnInit() {
    this.getGlobalRoles();
  }
  public getGlobalRoles() {
    const pickListLanguage = sessionStorage.getItem('pickListLanguage');
    const pickListItemOpath = `Picklist.Language='${pickListLanguage}' And Picklist.Name = 'Personenposition'`;
    this.subscriptions.push(
      this.dataService
        .readObjects(ObjectKeys.PICKLISTITEM, this.pickListItemColumns, pickListItemOpath)
        .pipe(first())
        .subscribe(
          (pickListData) => {
            if (Array.isArray(pickListData) && pickListData.length > 0) {
              this.dataSource = pickListData;
              this.showLoader = false;
              this.cdr.markForCheck();
            }
          },
          (error) => {
            console.error('Error fetching picklist data:', error);
            this.showLoader = false;
          }
        )
    );
  }
  public onCellPrepared(e) {
    if (e.rowType === 'data' && e.column.type === 'buttons') {
      e.cellElement.style.cursor = 'pointer';
      e.cellElement.innerHTML = DefaultIcons.CONTEXTMENU;
    }
  }

  public onCellClick(e) {
    if (e.rowType === 'data' && e.column.type === 'buttons') {
      e.cellElement.className = 'context-menu-icon' + e.rowIndex;
      e.cellElement.innerHTML = this.contextMenu.visible ? DefaultIcons.CLOSE : DefaultIcons.CONTEXTMENU;
      this.roleId = e.data.Id;
      this.permessionService.setRole(e.data);
      this.contextMenu.target = '.context-menu-icon' + e.rowIndex;
      this.contextMenu.instance.show();
    }
  }
  public openEditDialog() {
    this.loadPopup = true;
    this.cdr.detectChanges();
    if (this.createUserPopup) {
      this.createUserPopup.openUserPopup();
    }
  }
}
export class GlobalRole {
  Id: string;
  parentId: string;
  Value: string;
  Description: string;
  constructor(data) {
    Object.assign(this, data);
  }
}
